import { useMutation } from '@tanstack/react-query';
import { requestWorkspacePasswordReset } from '../centralIdentityAuth';

export const useRequestPasswordReset = () => useMutation({
  mutationFn: ({ email }) => requestWorkspacePasswordReset(email),
});
